import { Inject, inject, Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { SharedAuctionFacade } from 'libs/shared/models/auction/auction.models'
import * as BasePaddleNumberActions from 'libs/shared/paddle-numbers/data-access/src/lib/+state/base-paddle-numbers.actions'
import { catchError, map, of, switchMap, tap, withLatestFrom } from 'rxjs'
import { BasePaddleNumbersApiService } from './base-paddle-numbers-api.service'

@Injectable()
export class BasePaddleNumbersEffects {
  protected readonly actions$ = inject(Actions)

  checkPaddleNumberAvailability$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BasePaddleNumberActions.checkPaddleNumberAvailability),
      withLatestFrom(this.auctionFacade.urlName$),
      switchMap(([{ paddleNumber, onResponse }, urlName]) =>
        this.basePaddleNumbersApiService.checkPaddleNumberAvailable(paddleNumber, urlName).pipe(
          tap(
            (
              response: void | {
                paddle_number: string
              },
            ) => {
              if (!response) {
                onResponse(true)
              }
            },
          ),
          catchError(() => {
            onResponse(false)
            return of(BasePaddleNumberActions.checkPaddleNumberAvailabilityCheckDone())
          }),
          map(() => BasePaddleNumberActions.checkPaddleNumberAvailabilityCheckDone()),
        ),
      ),
    ),
  )

  getNextAvailablePaddleNumber$ = createEffect(() =>
    this.actions$.pipe(
      ofType(BasePaddleNumberActions.getNextAvailablePaddleNumber),
      withLatestFrom(this.auctionFacade.urlName$),
      switchMap(([action, urlName]) =>
        this.basePaddleNumbersApiService.getNextAvailablePaddleNumber(urlName).pipe(
          map((res) => {
            action.onSuccess(res.paddle_number)
            return BasePaddleNumberActions.getNextAvailablePaddleNumberDone()
          }),
        ),
      ),
    ),
  )

  constructor(
    private basePaddleNumbersApiService: BasePaddleNumbersApiService,
    @Inject('AuctionFacade') private auctionFacade: SharedAuctionFacade,
  ) {}
}
